import { IAppConfig } from '@recruitee/common';
import { LanguageConfig } from '@recruitee/i18n';

import { environment } from '../environments/environment';

const hostAndPort = `${environment.domain}${
  environment.port && environment.port !== 80 ? ':' + environment.port : ''
}`;

export const appConfig: IAppConfig = {
  apiUrl: `${environment.protocol}://${hostAndPort}/referral_portal`,
  authUrl: `${environment.protocol}://${hostAndPort.replace('api.', 'auth.')}/`,
  appUrl: `${environment.protocol}://${hostAndPort.replace('api.', '')}/`,
  webAppUrl: `${environment.protocol}://${hostAndPort.replace('api.', 'app.')}/`,
  hasHttps: environment.protocol === 'https',
  recaptchaSiteKey: environment.recaptchaSiteKey,
};

export const ExternalUrl = {
  RecruiteeDashboard: environment.webappUrl,
  RecruiteeLandingPage: environment.landingPageUrl,
  LinkedInDataArchiveRequestPage: 'https://www.linkedin.com/psettings/member-data',
  WalktroughVideo: 'https://www.youtube.com/watch?v=WtEnzVFdt-E',
  Footer: 'https://support.recruitee.com/collections/2061100',
};
export type IExternalUrl = typeof ExternalUrl;

export const languageConfig: LanguageConfig = {
  defaultLanguage: 'en',
  languages: ['en', 'nl', 'de', 'fr'],
};
